import { FC } from "react";
import clsx from "clsx";

import Select from "../../../custom/select/select";
import CustomMultiSelect from "../../../custom/customMultiSelect/customMultiSelect";

import TextArea from "./TextArea";

import styles from '../recruiting.module.scss';

import {
    reducerSingleVacancyStatusMultiSelect
} from "../../../../redux/reducer/recruiting/reducers/reducerSingleVacancy";
import { actionTest } from "../../../../redux/action/recruiting/actionVacancy";
import { matchingNameMultiselection, matchingNameMultiselectionExt } from "../../../../utils/matchingNameMultiselection";
import { BlocksFormProps, EventItem, ItemEmployee, Item } from "../../../../types/interfaces";

const LeftForm: FC<BlocksFormProps> = ({
    inputValues,
    nameSelect,
    statusName,
    selectChange,
    handleInputChange,
    options,
    data,
    editVacancy
}) => {
    const { regionsOptions, areasOptions, contractsOptions, supervisorsOptions, virtualSupervisorsOptions, projectsOptions, managersOptions, daysOptions } = options;
    const resultsupervisors = (inputValues?.supervisors || []).map((item: ItemEmployee) => {
        const foundObject = options.supervisorsOptions.find((obj: {value: number, label: string}) => obj.value === item.employee.id);
        return foundObject || { value: item.employee.id, label: item.employee.name };
    });
    const resultsupervisorsExt = matchingNameMultiselectionExt(inputValues?.supervisorsExt || [], supervisorsOptions).filter(Boolean);
    const resultVirtSupervisors = (inputValues?.virtualSupervisors || []).map((item: ItemEmployee) => {
        const foundObject = options.virtualSupervisorsOptions.find((obj: {value: number, label: string}) => obj.value === item.employee.id);
        return foundObject || { value: item.employee.id, label: item.employee.name };
    }).filter(Boolean);
    const resultVirtSupervisorsExt = matchingNameMultiselectionExt(inputValues?.virtualSupervisorsExt || [], virtualSupervisorsOptions).filter(Boolean);
    const matchingRegions = matchingNameMultiselection(inputValues.regions, inputValues?.formData?.regions);
    const matchingRegionsExt = matchingNameMultiselectionExt(inputValues.regionsExt, regionsOptions);
    const matchingAreas = matchingNameMultiselection(inputValues.areas, inputValues?.formData?.areas);
    const matchingAreasExt = matchingNameMultiselectionExt(inputValues.areasExt, areasOptions);
    const matchingContracts = matchingNameMultiselection(inputValues.contracts, inputValues?.formData?.contracts);
    const matchingContractsExt = matchingNameMultiselectionExt(inputValues.contractsExt, contractsOptions);
    const matchingDays = Array.isArray(inputValues.days) ? inputValues.days?.map((input: { [key: string]: string }) => {
        const val = typeof input === 'object' ? Object.values(input).toString() : input;
        const foundObject = daysOptions.find((obj: {value: string, label: string}) => obj.value === val)
        return foundObject || { value: input, label: Object.values(input) }
    }) : [];
    const matchingDaysExt = Array.isArray(inputValues.daysExt) ? inputValues.daysExt?.map((input: string) => {
        const val = typeof input === 'object' ? Object.values(input).toString() : input;
        const foundObject = daysOptions.find((obj: {value: string, label: string}) => obj.value === val)
        return foundObject || { value: input, label: Object.values(input) }
    }) : [];
    console.log(matchingDays,inputValues.days);
    const hour = inputValues.workload && inputValues.workload >= 60 ? inputValues.workload / 60 < 10 ? `0${Math.floor(inputValues.workload / 60)}` : `${Math.floor(inputValues.workload / 60)}` : '00';
    const minuts = inputValues.workload && inputValues.workload > 0 ? inputValues.workload % 60 < 10 ? `0${Math.floor(inputValues.workload % 60)}` : `${Math.floor(inputValues.workload % 60)}` : '00';
    const matchingProjects = matchingNameMultiselection(inputValues.projects, inputValues?.formData?.projects);
    const routesValues = inputValues?.routes && inputValues?.routes.map((el: {project:Item, routes: number[]}) => { return el.routes });
    return (
        <div className={styles.halfBlock}>
            <div className={styles.vacancyBlock}>
                <span className='section__title'>Проект из маршрута</span>
                <div className={clsx(
                    styles.subBlock,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <div className={styles.subBlock__right}>
                        <Select
                            disabled={!editVacancy}
                            value={nameSelect}
                            propsChange={(event: EventItem) =>
                                selectChange(event, 'type')
                            }
                            options={inputValues?.formData?.types.map((el: { [key: string]: string }[]) => ({
                                value: Object.keys(el),
                                label: Object.values(el),
                            }))}
                            className={clsx(styles.filterSelect, (data && data?.type?.changed) && styles.changed)}
                            placeholder={nameSelect ? nameSelect : 'Выбрать'}
                            name='type'
                            span='Тип вакансии'
                            isShowPlaceholder={true}
                        />
                    </div>
                </div>

                <div className={clsx(inputValues.type !== 'ON_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => {
                            }}
                            setState={() => {
                            }}
                            action={actionTest}
                            reducer={reducerSingleVacancyStatusMultiSelect}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Проект'
                            name='projects'
                            pageName='type2'
                            options={projectsOptions}
                            resetPages={() => {
                            }}
                            disabled={true}
                            visible={inputValues.type === 'NO_ROUTE'}
                            activeOptions={inputValues.projects}
                        />
                    </div>
                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingProjects && matchingProjects.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.projects?.changed) && styles.changed)}>
                            {matchingProjects && matchingProjects.map((item: { name: string }) => item.name).join(', ')}
                        </span>}
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={routesValues?.toString() || ''}
                        onChange={handleInputChange}
                        className={data && data?.routes?.changed ? styles.changed : ''}
                        name='routes'
                        type='text'
                        disabled={true}
                        placeholder=' '
                    />
                    <label>Маршрут</label>
                </div>

                <div className={clsx(inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => {
                            }}
                            setState={() => {
                            }}
                            action={actionTest}
                            reducer={reducerSingleVacancyStatusMultiSelect}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Виртуальный супервайзер'
                            name='virtualSupervisorsExt'
                            pageName='type2'
                            options={virtualSupervisorsOptions}
                            activeOptions={inputValues.virtualSupervisors}
                            resetPages={() => {
                            }}
                            disabled={true}
                            visible={inputValues.type === 'NO_ROUTE'}
                        />
                    </div>
                    {inputValues?.formData &&
                        <span
                            className={clsx((resultVirtSupervisors && resultVirtSupervisors.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisorsExt?.changed) && styles.changed)}>
                            {resultVirtSupervisors && resultVirtSupervisors.map((item: { label: string }) => item.label).join(', ')}
                        </span>}
                    {inputValues?.formData &&
                        <span
                            className={clsx((resultVirtSupervisorsExt && resultVirtSupervisorsExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisorsExt?.changed) && styles.changed, styles.notVisible)}>
                            {resultVirtSupervisorsExt && resultVirtSupervisorsExt.map((item: { label: string }) => item.label).join(', ')}
                        </span>}
                </div>

                <div className={clsx(inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => {
                            }}
                            setState={() => {
                            }}
                            action={actionTest}
                            reducer={reducerSingleVacancyStatusMultiSelect}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Супервайзер'
                            name='supervisors'
                            pageName='vacancy'
                            options={supervisorsOptions}
                            activeOptions={resultsupervisors}
                            resetPages={() => {
                            }}
                            disabled={true}
                            visible={inputValues.type === 'NO_ROUTE'}
                        />
                    </div>

                    {inputValues?.formData &&
                        <span
                            className={clsx((resultsupervisors && resultsupervisors.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisors?.changed) && styles.changed)}>
                            {resultsupervisors && resultsupervisors.map((item: { label: string }) => item.label).join(', ')}
                        </span>}
                    {inputValues?.formData &&
                        <span
                            className={clsx((resultsupervisorsExt && resultsupervisorsExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisors?.changed) && styles.changed, styles.notVisible)}>
                            {resultsupervisorsExt && resultsupervisorsExt.map((item: { label: string }) => item.label).join(', ')}
                        </span>}
                </div>

                <div className={clsx(inputValues.type !== 'ON_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => {
                            }}
                            setState={() => {
                            }}
                            action={actionTest}
                            reducer={reducerSingleVacancyStatusMultiSelect}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Руководитель проекта'
                            name='pm'
                            pageName='type2'
                            options={managersOptions}
                            resetPages={() => {
                            }}
                            disabled={true}
                            visible={inputValues.type === 'NO_ROUTE'}
                            activeOptions={inputValues.pm}
                        />
                    </div>
                    {inputValues?.formData &&
                        <span
                            className={clsx((inputValues?.pm && inputValues?.pm?.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.projects?.changed) && styles.changed)}>
                            {inputValues.pm && inputValues?.pm?.map((item: Item) => item.name).join(', ')}
                        </span>}
                </div>
            </div>
            <div className={styles.vacancyBlock}>
                <span className='section__title'>Описание из маршрута</span>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={(inputValues?.modifiedDate?.value?.slice(0, 16)) || ''}
                        name='modifiedDate'
                        type='datetime-local'
                        disabled={true}
                    />
                    <label>Дата изменения вакансии</label>
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={inputValues.salary || ''}
                        className={data && data?.salary?.changed ? styles.changed : ''}
                        name='salary'
                        type='text'
                        disabled={true}
                        placeholder=' '
                    />
                    <label>Зарплата</label>
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={inputValues.revenue || ''}
                        className={data && data?.revenue?.changed ? styles.changed : ''}
                        name='revenue'
                        type='text'
                        disabled={true}
                        placeholder=' '
                    />
                    <label>Выручка</label>
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <div className={styles.subBlock__right}>
                        <Select
                            disabled={!editVacancy}
                            value={statusName}
                            isShowPlaceholder={true}
                            propsChange={(event: EventItem) =>
                                selectChange(event, 'status')
                            }
                            options={inputValues?.formData?.status.map((el: { [key: string]: string }) => ({
                                value: Object.keys(el),
                                label: Object.values(el),
                            }))}
                            className={clsx(styles.filterSelect, (data && data?.status?.changed) ? styles.changed : '')}
                            placeholder={statusName || 'Выбрать'}
                            name='status'
                            span='Статус вакансии'
                        />
                    </div>
                </div>

                <div className={clsx(inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => {
                            }}
                            setState={() => {
                            }}
                            action={actionTest}
                            reducer={reducerSingleVacancyStatusMultiSelect}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Регион'
                            name='regions'
                            pageName='vacancy'
                            options={regionsOptions}
                            activeOptions={matchingRegions}
                            resetPages={() => {
                            }}
                            disabled={true}
                            visible={inputValues.type === 'NO_ROUTE'}
                        />
                    </div>

                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingRegions && matchingRegions.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.regions?.changed) && styles.changed)}>
                            {matchingRegions && matchingRegions.map((item: { name: string }) => item.name).join(', ')}
                        </span>}
                    {<span
                        className={clsx((matchingRegionsExt && matchingRegionsExt.length > 0) && styles.span__elem_active, styles.span__elem, styles.notVisible)}>
                        {matchingRegionsExt && matchingRegionsExt.map((item: { name: string }) => item.name).join(', ')}
                    </span>}
                </div>

                <div className={clsx(inputValues?.type === 'NO_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => { }}
                            setState={() => { }}
                            action={() => { }}
                            reducer={() => { }}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Область'
                            name='areas'
                            pageName='vacancy'
                            options={data?.formData?.areas}
                            activeOptions={matchingAreas}
                            resetPages={() => { }}
                            disabled={true}
                            visible={inputValues?.type === 'NO_ROUTE'}
                        />
                    </div>

                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingAreas && matchingAreas.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.areas?.changed) && styles.changed)}>
                            {matchingAreas && matchingAreas.map((item: { name: string }) => item.name).join(', ')}
                        </span>}
                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingAreasExt && matchingAreasExt.length > 0) && styles.span__elem_active, styles.span__elem, styles.notVisible)}>
                            {matchingAreasExt && matchingAreasExt.map((item: { name: string }) => item.name).join(', ')}
                        </span>}
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={inputValues?.cities?.join(', ') || ''}
                        className={(data && data?.cities?.changed) ? styles.changed : ''}
                        placeholder=' '
                        name='cities'
                        type='text'
                        disabled={true}
                    />
                    <label>Город</label>
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={inputValues?.subway || ''}
                        onChange={handleInputChange}
                        className={data && data?.subway?.changed ? styles.changed : ''}
                        placeholder=' '
                        name='subway'
                        type='text'
                        disabled={!editVacancy}
                    />
                    <label>Метро/Район</label>
                </div>

                <TextArea
                    inputValues={inputValues}
                    handleInputChange={handleInputChange}
                    name='merchs'
                    title='Логин/Локация'
                    editVacancy={editVacancy}
                    data={data}
                    notVisible={inputValues.type === 'NO_ROUTE'}
                    isDisabled={true}
                />
                <TextArea
                    inputValues={inputValues}
                    name='merchsExt'
                    title='Логин/Локация'
                    notVisible={true}
                />

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={inputValues.name || ''}
                        onChange={handleInputChange}
                        className={data && data?.name?.changed ? styles.changed : ''}
                        name='name'
                        type='text'
                        disabled={editVacancy ? inputValues.type !== 'LOST_ROUTE' : true}
                        placeholder=' '
                    />
                    <label>Название вакансии</label>
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={(inputValues?.createdDate?.slice(0, 16)) || ''}
                        name='dateInputFormat'
                        type='datetime-local'
                        disabled={true}
                    />
                    <label>Дата создания</label>
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <div className={styles.subBlock__right}>
                        <Select
                            disabled={true}
                            value={inputValues?.schedule && Object.values(inputValues?.schedule)[0]}
                            isShowPlaceholder={true}
                            propsChange={(event: EventItem) =>
                                selectChange(event, 'schedule')
                            }
                            options={inputValues?.formData?.schedule.map((el: { [key: string]: string }) => ({
                                value: Object.keys(el),
                                label: Object.values(el),
                            }))}
                            className={clsx(styles.filterSelect, (data && data?.schedule?.changed) && styles.changed)}
                            placeholder={(inputValues.schedule && Object.values(inputValues.schedule)[0]) || 'Выбрать'}
                            name={'schedule'}
                            span='График'
                        />
                    </div>
                </div>

                <div className={clsx(inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => { }}
                            setState={() => { }}
                            action={actionTest}
                            reducer={() => { }}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Дни недели'
                            name='days'
                            pageName='days'
                            options={daysOptions}
                            activeOptions={matchingDays}
                            resetPages={() => { }}
                            disabled={true}
                            visible={inputValues.type === 'NO_ROUTE'}
                        />
                    </div>

                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingDays && matchingDays.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.contracts?.changed) && styles.changed)}>
                            {matchingDays && matchingDays.map((item: { label: string }) => item.label).join(', ')}
                        </span>}
                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingDaysExt && matchingDaysExt.length > 0) && styles.span__elem_active, styles.span__elem, styles.notVisible)}>
                            {matchingDaysExt && matchingDaysExt.map((item: { label: string }) => item.label).join(', ')}
                        </span>}
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={inputValues.posCount || ''}
                        className={data && data?.posCount?.changed ? styles.changed : ''}
                        name='posCount'
                        type='number'
                        disabled={true}
                        placeholder=' '
                    />
                    <label>Количество ТТ</label>
                </div>

                <div className={clsx(inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
                    <div className='reports__region_block-select'>
                        <CustomMultiSelect
                            setLoading={() => { }}
                            setState={() => { }}
                            action={actionTest}
                            reducer={() => { }}
                            inputValues={inputValues}
                            isShowPlaceholder={true}
                            placeholder='Контракты'
                            name='contracts'
                            pageName='vacancy'
                            options={contractsOptions}
                            activeOptions={matchingContracts}
                            resetPages={() => { }}
                            disabled={true}
                            visible={inputValues.type === 'NO_ROUTE'}
                        />
                    </div>

                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingContracts && matchingContracts.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.contracts?.changed) && styles.changed)}>
                            {matchingContracts && matchingContracts.map((item: { name: string }) => item.name).join(', ')}
                        </span>}
                    {inputValues?.formData &&
                        <span
                            className={clsx((matchingContractsExt && matchingContractsExt.length > 0) && styles.span__elem_active, styles.span__elem, styles.notVisible)}>
                            {matchingContractsExt && matchingContractsExt.map((item: { name: string }) => item.name).join(', ')}
                        </span>}
                </div>

                <div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                    inputValues.type === 'NO_ROUTE' && styles.notVisible
                )}>
                    <input
                        value={`${hour}:${minuts}` || ''}
                        className={(data && data?.workload?.changed) ? styles.changed : ''}
                        name='workload'
                        type='text'
                        disabled={true}
                        placeholder=' '
                    />
                    <label>Длительность рабочего дня</label>
                </div>

                <TextArea
                    inputValues={inputValues}
                    handleInputChange={handleInputChange}
                    name='addresses'
                    title='Список адресов'
                    editVacancy={editVacancy}
                    data={data}
                    notVisible={inputValues.type === 'NO_ROUTE'}
                    isDisabled={true}
                />
                <TextArea
                    inputValues={inputValues}
                    name='addressesExt'
                    title='Логин/Локация'
                    notVisible={true}
                />
                <TextArea
                    inputValues={inputValues}
                    handleInputChange={handleInputChange}
                    name='description'
                    title='Описание'
                    editVacancy={editVacancy}
                    data={data}
                    notVisible={inputValues.type === 'NO_ROUTE'}
                    isDisabled={!editVacancy}
                />
                <TextArea
                    inputValues={inputValues}
                    handleInputChange={handleInputChange}
                    name='url'
                    title='Ссылка на вакансию'
                    editVacancy={editVacancy}
                    data={data}
                    notVisible={inputValues.type === 'NO_ROUTE'}
                    isDisabled={!editVacancy}
                />
            </div>


            <div className={styles.vacancyBlock}>
                <span className='section__title'>Требования к кандидату</span>
                <TextArea
                    inputValues={inputValues}
                    handleInputChange={handleInputChange}
                    name='comment'
                    title='Комментарий ОПП'
                    editVacancy={editVacancy}
                    data={data}
                    notVisible={inputValues.type === 'NO_ROUTE'}
                    isDisabled={!editVacancy}
                />
            </div>

        </div>
    )
}


export default LeftForm;
